export const manifest = {
  screens: {
    scr_wvtnjq: { name: "Home", route: "/" },
  },
}
